// socket vars
export const SOCKET_TIME_OUT = process.env.REACT_APP_SOCKET_TIME_OUT
  ? Number(process.env.REACT_APP_SOCKET_TIME_OUT)
  : 20000
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || 'https://my-api.ahanoffline.ir/callcenter'

// key cloak vars
export const KEY_CLOAK_URL =
  process.env.REACT_APP_KEY_CLOAK_URL || 'https://accounts.ahanonline.com/auth'
export const KEY_CLOAK_REALM =
  process.env.REACT_APP_KEY_CLOAK_REALM || 'ahanoffline'
export const KEY_CLOAK_CLIENT_ID =
  process.env.REACT_APP_KEY_CLOAK_CLIENT_ID || 'callcenter-panel'

// api vars
export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT
  ? Number(process.env.REACT_APP_API_TIMEOUT)
  : undefined
export const API_CALL_BASE_URL =
  process.env.REACT_APP_API_CALL_BASE_URL || 'https://callcenter.ahanoffline.ir'
export const API_CALLCENTER_BASE_URL =
  process.env.REACT_APP_API_CALLCENTER_BASE_URL ||
  'https://my-api.ahanoffline.ir/callcenter/'
export const API_CRM_BASE_URL =
  process.env.REACT_APP_API_CRM_BASE_URL ||
  'https://callcenter-api.ahanoffline.ir'

export const API_Manager_BASE_URL =
  process.env.REACT_APP_API_Manager_BASE_URL ||
  'https://my-api.ahanoffline.ir/callcenter'

export const API_HOME_BASE_URL =
  process.env.REACT_APP_API_HOME_BASE_URL || 'https://my-api.ahanoffline.ir/home'

export const API_BI_BASE_URL =
  process.env.REACT_APP_API_BI_BASE_URL || 'https://my-api.ahanoffline.ir/bi'

export const API_SALES_BASE_URL =
  process.env.REACT_APP_API_SALES_BASE_URL ||
  'https://my-api.ahanoffline.ir/sales'

//others
export const BASE_CRM_URL =
  process.env.REACT_APP_BASE_CRM_URL || 'http://xrmtest/ahanonline/main.aspx'
export const CALL_CENTER_MANAGER_SCRIPT =
  process.env.REACT_APP_CALL_CENTER_MANAGER_SCRIPT ||
  'https://callcenter-manager.ahanoffline.ir/injectScript.js'
export const RAYCHAT_IS_ENABLED =
  process.env.REACT_APP_RAYCHAT_IS_ENABLED || false
export const TAG_MANAGER_IS_ENABLED =
  process.env.REACT_APP_TAG_MANAGER_IS_ENABLED || false
